import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, InputGroup } from "react-bootstrap";
import { BASE_URL } from "../../../constants";
import Select from 'react-select';
import axios from 'axios';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//const DiscountModal = ({ show, handleClose, handleSave }) => {
const ViewRcptkModal = ({ show, handleClose, onRowSelect }) => {

  const [searchGR_No, setSearchGR_No] = useState();
  const [searchSection, setSearchSection] = useState();

  const [searchResults, setSearchResults] = useState([]);
  const [ddlSections, setDdlSections] = useState([]);
  const [ddlGRNos, setDdlGRNos] = useState([]);

  useEffect(() => {
    
    const fetchLists = async () => {
      try {
        // const [ sectionRes] = await Promise.all([
        //     axios.get(`${BASE_URL}/api/ddl_sections`),
        // ]);

        // setDdlSections(sectionRes.data);

        const sec = await axios.get(`${BASE_URL}/api/ddl_sections`);
        setDdlSections(sec.data);

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchLists();

  }, []);

  useEffect(() => {
    
    const fetchLists = async () => {
      try {

        populateDdlGR();

      } catch (err) {
        console.error("Search fetch error:", err);
      }
    };

    fetchLists();

  }, [searchSection]);

  useEffect(() => {
    if (searchSection && searchGR_No) {
      populateGrid();
    }
  }, [searchSection, searchGR_No]);

  const handleSearch = async () => {

    if (!searchSection || searchSection === '') {
      toast.error('Please select Section.');
      return;
    }

    try {
      const response = await axios.get(`${BASE_URL}/api/get_student_edit_view`, {
        params: {p_section_id: searchSection, p_gr_no: searchGR_No || 0},
      });

      setSearchResults(response.data);

    } catch (error) {
      console.error('Search failed:', error);
    }

  };

  const handleClear = async () => {

    setSearchGR_No(null);
    setSearchSection('');
    setSearchResults([]);

  }

  // const handleSectionChange = async (e) => {

  //   const sectionId = e.target.value;

  //   setDdlGRNos([]);
  //   setSearchSection(sectionId);
  //   setSearchGR_No(null);

  //   if (!sectionId) return;

  //   const studResponse = await axios.get(`${BASE_URL}/api/ddl_stud_name_gr`,
  //     { params: { p_Section_Id: sectionId } });

  //   setDdlGRNos(studResponse.data);
    
  // }

  const populateDdlGR = async () => {

    try {

      setSearchGR_No(null);
      setDdlGRNos([]);
      setSearchResults([]);

      if (!searchSection) return;

      const studResponse = await axios.get(`${BASE_URL}/api/ddl_stud_name_gr`,
        { params: { p_Section_Id: searchSection } });

      setDdlGRNos(studResponse.data);

      // populateGrid();

    } catch(e) {

    }

  }

  const populateGrid = async () => {

    try {

      if (!searchSection || !searchGR_No) return;

      const response = await axios.get(`${BASE_URL}/api/get_student_list`, {
        params: { p_section_id: searchSection, p_gr_no: searchGR_No || 0 }});

      setSearchResults(response.data);

    } catch(e) {

    }

  }

  // const handleGrBlur = () => {

  //   populateGrid();

  // }

  const handleGrChange = (selectedOption) => {

    try {

      setSearchGR_No(selectedOption ? selectedOption.value : "");

    } catch (e) {
      toast.error('Unable to retrieve fees data.');
    }

  };

  const grNoOptions = ddlGRNos.map(code => ({
    value: String(code.gr_no),
    label: code.stud_name
  })) || [];

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Search Student</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <Form className="mb-3">
          {/* === Row 1 === */}
          <div className="row mb-3">

            {/* Section Dropdown */}
            <Form.Group className="col-md-6">
              <InputGroup>
                <InputGroup.Text style={{ width: "200px" }}>Section</InputGroup.Text>
                <Form.Select
                  value={searchSection} 
                  //onChange={handleSectionChange}
                   onChange={(e) => setSearchSection(e.target.value)}> 
                  <option value="">-- Section --</option>
                  {ddlSections.map(sec => (
                    <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
                  ))}
                </Form.Select>
              </InputGroup>
            </Form.Group>

            {/* <Form.Group className="col-md-4">
              <InputGroup>
                <InputGroup.Text style={{ width: "120px" }}>GR No</InputGroup.Text>
                <input style={{textAlign: 'right'}}
                  className="form-control"
                  name="searchRcptNo"
                  value={searchRcptNo}
                  onChange={(e) => setSearchRcptNo(e.target.value)}
                />
              </InputGroup>
            </Form.Group> */}

            <div className="col-md-2">

            </div>

            <div className="col-md-2">
              <Button variant="primary" onClick={handleSearch} className="w-100">
                Search
              </Button>
            </div>
            <div className="col-md-2">
                 <Button variant="secondary" onClick={handleClear} className="w-100">
                Clear
              </Button>
            </div>

          </div>

          {/* === Row 2 === */}
          <div className="row align-items-end">

            <Form.Group className="col-md-12">
              <InputGroup>
                <InputGroup.Text style={{ width: "200px" }}>GR No. / Student Name</InputGroup.Text>
                <div style={{ flex: 1 }}>
                  <Select name="searchGR_No" options={grNoOptions}
                    value={grNoOptions.find(option => String(option.value) === String(searchGR_No)) || null}
                    // onBlur={handleGrBlur}
                    onChange={handleGrChange} placeholder="Search by GR No / Student name ..." />
                </div>
              </InputGroup>
            </Form.Group>
          </div>
        </Form>
        {/* <Table bordered hover responsive> */}
        <div style={{ minHeight: '430px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table-modal scty-custom-table hover-table-rcpt">
            <thead>
              <tr>
                <th style={{ width: '7%', textAlign: 'left' }}>Section</th>
                <th style={{ width: '7%', textAlign: 'left' }}>GR No</th>
                <th style={{ width: '33%', textAlign: 'left' }}>Student Name</th>
                <th style={{ width: '7%', textAlign: 'center' }}>Current Std/Div</th>
              </tr>
            </thead>
            <tbody>
              {searchResults.length === 0 ? (
                <tr><td colSpan="4" className="text-center">No Data</td></tr>
              ) : (
                searchResults.map((row, index) => (
                  <tr key={index} onClick={() => onRowSelect(row)} style={{ cursor: 'pointer' }}>
                    <td style={{ textAlign: 'left' }}>{row.sect_name}</td>
                    <td style={{ textAlign: 'left' }}>{row.gr_no}</td>
                    <td style={{ textAlign: 'left' }}>{row.stud_name}</td>
                    <td style={{ textAlign: 'left' }}>{row.curr_std_div}</td>
                  </tr>
                ))
              )}
            </tbody>
            {/* </Table> */}
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="warning" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewRcptkModal;
